// Dev mock — MUST BE REMOVED once real integration ships `type` data.
// Generated dynamically at module-load so the user always has data for
// navigable dates around "today" (covers ~60 days back). Each hour has
// values for HT and NT (both in the "tariff" aggregation_group → stacked).

type ConsumptionPoint = {
  timestamp: string
  value: number
  type?: string
}

const HT_BY_HOUR = [
  0.2, 0.18, 0.18, 0.18, 0.2, 0.25, 0.4, 0.7, 0.9, 0.8, 0.7, 0.6, 0.55, 0.5,
  0.5, 0.55, 0.7, 0.9, 1.1, 1.0, 0.8, 0.6, 0.4, 0.3
]
const NT_BY_HOUR = [
  0.5, 0.45, 0.4, 0.35, 0.35, 0.4, 0.5, 0.3, 0.2, 0.15, 0.1, 0.1, 0.1, 0.1, 0.1,
  0.15, 0.2, 0.25, 0.3, 0.35, 0.45, 0.55, 0.6, 0.55
]

const DAYS_OF_HISTORY = 0.5
const SLOTS_PER_HOUR = 4 // 15-min granularity
// Slight intra-hour variation so 15-min bars aren't visually identical.
const QUARTER_WEIGHTS = [1.05, 0.95, 1.0, 1.0]

const buildHourlyPattern = (): ConsumptionPoint[] => {
  const out: ConsumptionPoint[] = []
  // Anchor on "today" at local midnight so each generated slot lands on
  // a clean local hour.
  const anchor = new Date()

  anchor.setHours(0, 0, 0, 0)

  for (let dayOffset = -DAYS_OF_HISTORY; dayOffset <= 1; dayOffset += 1) {
    for (let hour = 0; hour < 24; hour += 1) {
      // Hourly totals, distributed across 4 × 15-min slots so the chart
      // has data at every PT15M slot. Sum across quarters ≈ hourly value.
      for (let q = 0; q < SLOTS_PER_HOUR; q += 1) {
        const slot = new Date(anchor)

        slot.setDate(anchor.getDate() + dayOffset)
        slot.setHours(hour, q * (60 / SLOTS_PER_HOUR), 0, 0)
        const ts = slot.toISOString()
        const w = QUARTER_WEIGHTS[q] / SLOTS_PER_HOUR

        out.push({ timestamp: ts, value: HT_BY_HOUR[hour] * w, type: 'ht' })
        out.push({ timestamp: ts, value: NT_BY_HOUR[hour] * w, type: 'nt' })
      }
    }
  }

  return out
}

export const MOCK_CONSUMPTIONS: { consumptions: ConsumptionPoint[] } = {
  consumptions: buildHourlyPattern()
}

// Stacked-bar fixture — HT + NT share one aggregation_group and stack
// in a single bar. Identical to MOCK_CONSUMPTIONS now that the base mock
// only emits HT/NT, but kept as a named export for fixture clarity.
export const MOCK_CONSUMPTIONS_STACKED: typeof MOCK_CONSUMPTIONS = {
  consumptions: MOCK_CONSUMPTIONS.consumptions.filter(
    (c) => c.type === 'ht' || c.type === 'nt'
  )
}

// Non-aggregation-group fixture — single untyped series. Pair with
// UNGROUPED_TYPE_OPTIONS (or no type_options at all) so the chart renders
// a flat ungrouped consumption line.
export const MOCK_CONSUMPTIONS_FLAT: typeof MOCK_CONSUMPTIONS = {
  consumptions: MOCK_CONSUMPTIONS.consumptions
    .filter((c) => c.type === 'ht' || c.type === 'nt')
    .reduce<{ timestamp: string; value: number }[]>((acc, point) => {
      const existing = acc.find((p) => p.timestamp === point.timestamp)

      if (existing) existing.value += point.value
      else acc.push({ timestamp: point.timestamp, value: point.value })

      return acc
    }, [])
}
